import i18n from "i18next"
import {
    chatEN,
    commonEN,
    sidebarEN,
    majorEN,
    termEN,
    workflowEN,
    courseEN,
    userEN,
    admissionEN,
    financialAidEN,
    degreeLevelEN,
    departmentsEN,
    resourcesEN,
    resourcesTypesEN,
    campusesEN,
    calendarEN,
    settingsEN,
    tasksEN,
    externshipEN,
    academicsEN,
    coaEN,
    studentEN,
    superadminEN,
    homeEN,
    documentsEN,
    activitiesEN,
    calendarEventsEN,
    studentServicesEN,
    attendanceReportEN,
    concernEN,
    reportsEN,
    templatesEN,
    studentAccountEN,
    notificationEN,
    kitEN
} from "../locale/en"
import {
    chatDE,
    commonDE,
    sidebarDE,
    majorDE,
    termDE,
    workflowDE,
    courseDE,
    userDE,
    admissionDE,
    financialAidDE,
    degreeLevelDE,
    departmentsDE,
    resourcesDE,
    resourcesTypesDE,
    campusesDE,
    calendarDE,
    settingsDE,
    tasksDE,
    externshipDE,
    academicsDE,
    coaDE,
    studentDE,
    superadminDE,
    homeDE,
    documentsDE,
    activitiesDE,
    calendarEventsDE,
    studentServicesDE,
    attendanceReportDE,
    concernDE,
    reportsDE,
    templatesDE,
    studentAccountDE,
    notificationDE
} from "../locale/de"
import {reportsES} from "../locale/es"

const locale: string = typeof window !== "undefined" ? window.localStorage.getItem("locale") : "en"

i18n.init({
    interpolation: {escapeValue: false},
    lng: locale,
    fallbackLng: "en",
    resources: {
        en: {
            chat: chatEN,
            common: commonEN,
            sidebar: sidebarEN,
            major: majorEN,
            term: termEN,
            workflow: workflowEN,
            course: courseEN,
            user: userEN,
            admission: admissionEN,
            financialAid: financialAidEN,
            degreeLevel: degreeLevelEN,
            departments: departmentsEN,
            resources: resourcesEN,
            resourcesTypes: resourcesTypesEN,
            campuses: campusesEN,
            calendar: calendarEN,
            settings: settingsEN,
            tasks: tasksEN,
            externship: externshipEN,
            academics: academicsEN,
            coa: coaEN,
            student: studentEN,
            superadmin: superadminEN,
            home: homeEN,
            documents: documentsEN,
            activities: activitiesEN,
            calendarEvents: calendarEventsEN,
            studentServices: studentServicesEN,
            attendanceReport: attendanceReportEN,
            concern: concernEN,
            reports: reportsEN,
            templates: templatesEN,
            studentAccount: studentAccountEN,
            notification: notificationEN,
            kit: kitEN
        },
        de: {
            chat: chatDE,
            common: commonDE,
            sidebar: sidebarDE,
            major: majorDE,
            term: termDE,
            workflow: workflowDE,
            course: courseDE,
            user: userDE,
            admission: admissionDE,
            financialAid: financialAidDE,
            degreeLevel: degreeLevelDE,
            departments: departmentsDE,
            resources: resourcesDE,
            resourcesTypes: resourcesTypesDE,
            campuses: campusesDE,
            calendar: calendarDE,
            settings: settingsDE,
            tasks: tasksDE,
            externship: externshipDE,
            academics: academicsDE,
            coa: coaDE,
            student: studentDE,
            superadmin: superadminDE,
            home: homeDE,
            documents: documentsDE,
            activities: activitiesDE,
            calendarEvents: calendarEventsDE,
            studentServices: studentServicesDE,
            attendanceReport: attendanceReportDE,
            concern: concernDE,
            reports: reportsDE,
            templates: templatesDE,
            studentAccount: studentAccountDE,
            notification: notificationEN,
            kit: kitEN
        },
        es: {
            reports: reportsES
        }
    }
})

export default i18n
